// extracted by mini-css-extract-plugin
module.exports = {"startupContainer":"Startup_startupContainer__2A2G3","wrapper":"Startup_wrapper__3tNqX","RHS":"Startup_RHS__2nzhW"};